import { useMemo } from "react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Form from "react-bootstrap/Form";
import { Placement } from "react-bootstrap/esm/types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import styles from "./idw-form-label.less";

type IdwFormLabelProps = {
    isRequired: boolean;
    labelWidth?: LabelWidthTypes;
    label: string;
    tooltipText?: string;
    tooltipTextPosition?: Placement;
    layout?: LayoutTypes;
    className?: string;
};

export const IdwFormLabel = (props: IdwFormLabelProps) => {
    const {
        isRequired,
        labelWidth,
        label,
        tooltipText,
        tooltipTextPosition,
        layout,
        className
    } = props;

    const labelClassName = useMemo(() => {
        if (layout === LayoutTypes.COLUMN) {
            return styles.fullLabel;
        }
        switch (labelWidth) {
            case LabelWidthTypes.EXTRA_SMALL:
                return styles.extraSmallLabel;
            case LabelWidthTypes.SMALL:
                return styles.smallLabel;
            case LabelWidthTypes.MEDIUM:
                return styles.mediumLabel;
            case LabelWidthTypes.LARGE:
                return styles.largeLabel;
            default:
                return styles.smallLabel;
        }
    }, [layout, labelWidth]);

    const labelLayoutClassName = useMemo(() => {
        return layout === LayoutTypes.COLUMN ? styles.columnLabel : styles.rowLabel;
    }, [layout]);

    const renderTooltip = (props: any) => {
        return (
            <Tooltip {...props}>
                {tooltipText}
            </Tooltip>
        );
    };

    return (
        <div className={styles.idwFormLabel}>
            <Form.Label aria-required={isRequired} className={classNames(labelClassName, labelLayoutClassName, className ? className : "")}>
                <span dangerouslySetInnerHTML={{ __html: label }} />
                {isRequired && label && <span className={classNames(styles.required, "required")}>*</span>}
                {tooltipText && (
                    <OverlayTrigger overlay={renderTooltip} placement={tooltipTextPosition}>
                        <span className={styles.tooltipContainer}><FontAwesomeIcon icon={faQuestionCircle} /></span>
                    </OverlayTrigger>
                )}
            </Form.Label>
        </div>
    );
};